import { create } from 'zustand';
import type { User } from '../types/user';

interface AuthState {
  user: User | null;
  loading: boolean;
  needsDisplayName: boolean;
  setUser: (user: User | null) => void;
  setLoading: (loading: boolean) => void;
  setNeedsDisplayName: (v: boolean) => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  loading: true,
  needsDisplayName: false,
  setUser: (user) => set({ user }),
  setLoading: (loading) => set({ loading }),
  setNeedsDisplayName: (needsDisplayName) => set({ needsDisplayName }),
}));
